import { TableBody, TableHeader } from '@fluentui/react-components';
import type { Table } from '@tanstack/react-table';
import { TableVirtuoso } from 'react-virtuoso';
import { ResizableTableLoading } from './_shared/loading/index.js';
import { ResizableTableRow } from './_shared/row/index.js';
import { ResizableTable } from './_shared/table/index.js';
import { ResizableTableEmptyPlaceholder } from './components/empty-placeholder/index.js';
import type { ContextModel } from './hooks/_shared/context.js';
import { useStyles } from './styles.js';

export function ResizableTableVirtualized<TData>({
    context,
    table,
    data,
    loading,
    FixedHeaderContent,
}: {
    context: ContextModel<TData>;
    table: Table<TData>;
    data: TData[];
    loading?: boolean;
    FixedHeaderContent: () => JSX.Element;
}) {
    return !data || loading ? (
        <ResizableTableLoading context={context} table={table} FixedHeaderContent={FixedHeaderContent} />
    ) : (
        <TableVirtuoso
            context={context as any} // TODO: Fix typing
            totalCount={context.rows.length}
            fixedHeaderContent={FixedHeaderContent}
            components={{
                Table: ResizableTable,
                TableHead: TableHeader as any, // TODO: Fix typing
                TableBody: TableBody as any, // TODO: Fix typing
                TableRow: ResizableTableRow,
                EmptyPlaceholder: ResizableTableEmptyPlaceholder,
            }}
        />
    );
}

export function ResizableTableNonVirtualized<TData>({
    context,
    data,
    loading,
    table,
    FixedHeaderContent,
}: {
    context: ContextModel<TData>;
    data: TData[];
    loading?: boolean;
    table: Table<TData>;
    FixedHeaderContent: () => JSX.Element;
}) {
    const styles = useStyles();

    const rows = table.getRowModel().rows;

    return !data || loading ? (
        <ResizableTableLoading context={context} table={table} FixedHeaderContent={FixedHeaderContent} />
    ) : (
        <ResizableTable context={context}>
            <TableHeader className={styles.header}>
                <FixedHeaderContent />
            </TableHeader>

            <TableBody>
                {rows.length ? (
                    rows.map((row, index) => <ResizableTableRow key={row.id} data-index={index} context={context} />)
                ) : (
                    <ResizableTableEmptyPlaceholder />
                )}
            </TableBody>
        </ResizableTable>
    );
}
